import React from 'react';
import Navbar from './global-components/navbar';
import PageHeader from './global-components/page-header';
import AddNew from './section-components/add-new';
import Footer from './global-components/footer';
import BlogContact from '../utils/blogContact';

const AddProperty = () => {
    return <div>
        <Navbar />
        <PageHeader headertitle="Add Property" />
        <AddNew />
        <div style={{paddingBottom : '35px'}}>
       <BlogContact />
    </div>
        <Footer />
    </div>
}

export default AddProperty

